'use client'

import { createContext, PropsWithChildren, useContext } from 'react'

import { useSuspenseGetLoad } from '@/app/@protected/loads/[id]/(details)/_components/load-context/use-suspense-get-load.ts'

type Context = {
  data: ReturnType<typeof useSuspenseGetLoad>['data']
}

const Context = createContext<Context | null>(null)

export const LoadProvider = ({
  children,
  data,
}: PropsWithChildren<{
  data: ReturnType<typeof useSuspenseGetLoad>['data']
}>) => {
  return <Context.Provider value={{ data }} data-sentry-element="Context.Provider" data-sentry-component="LoadProvider" data-sentry-source-file="context.tsx">{children}</Context.Provider>
}

export const useLoadContext = () => {
  const context = useContext(Context)

  if (!context) {
    throw new Error('useLoadContext should be used within <LoadProvider>')
  }

  return context
}
